import { ELEMENT_TYPES } from '../constants';
import { Deserializable } from './deserializable';
import { ExerciseModel } from './exercise.model';

export class ElementModel implements Deserializable {

  // columns
  id: number;
  type: string;
  name: string;
  title: string;
  position: number;
  metadata: any;
  content: any;
  permissions: Array<any>;
  misc: any;

  // relations
  exercise: ExerciseModel = null;

  deserialize(input: any): this {
    Object.assign(this, input);
    if (this.exercise !== null && this.exercise !== undefined) {
      this.exercise = new ExerciseModel().deserialize(this.exercise);
    }
    return this;
  }

  getTypename(): string {
    return ELEMENT_TYPES[this.type];
  }

  get exercisename(): string {
    return (this.exercise !== null) ? this.exercise.name : '';
  }

}
